import masterDataProto from 'src/Library/MasterDataType';
import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useReduxState } from "src/hooks/useRedux";
import { useStaticSelect } from "src/hooks/form/useSelect";
import { SECarrerType } from 'src/components/pages/shipment-execution/SE.interfaces';

const useCarriers = <T>(
  props: useFieldProps<T>,
  defaultCarrierType: SECarrerType | 'ALL',
) => {
  const field = useStaticSelect<ReturnType<typeof getOptions>, T>(props);

  const [type, setType] = React.useState(defaultCarrierType);
  const carriers: typeof masterDataProto.globalCarriers = useReduxState(["masterData", "globalCarriers"]).value;

  React.useEffect(() => {
    /** Resetting only those value whose type mismatches selected type */
    if (!((carriers.find(el => el?.id === field.value)?.type === 'AIR' &&
          type === 'CARRIER') ||
          carriers.find(el => el?.id === field.value)?.type === 'SEA' &&
          type === 'SL')) {
            field.setValue("");
          }

    field.setOptionsData(getOptions(), (data: any) => {
      return data?.map((el) => ({ key: el.id, label: el.name })) || [];
    });
  }, [carriers, type]);

  const getOptions = () => {
    const airCarriers = carriers.filter(el => el.type === 'AIR');
    const slCarriers = carriers.filter(el => el.type === 'SEA');

    switch (type){
      case 'SL':
        return slCarriers;
      case 'CARRIER':
        return airCarriers;
      case 'ALL':
      default: 
        return carriers;
    }
  };
  // TODO
  // const disableSL = () => {
  //   const { isEdit, data, form } = superProps;
  //   const { bookingData, prefilling } = superState;
  //   return prefilling
  //     || bookingData?.chargeDetails?.ffCarrier
  //     || (isEdit && data.shippingLine?.id);
  // };

  return {
    ...field,
    setType,
  };
};

export default useCarriers;
